var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHeartOutlinedWithoutFrame(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.99263 5.27347L6.77345 3.54422C6.23337 2.77819 5.37667 2.2998 4.4181 2.2998C2.8463 2.2998 1.49939 3.62287 1.49939 5.3487C1.49939 5.84304 1.78659 6.63379 2.49452 7.68762C3.17062 8.69405 4.09829 9.74853 5.0656 10.726C6.0266 11.6972 6.99281 12.5585 7.72166 13.1789C7.81882 13.2616 7.9116 13.3399 7.99939 13.4134C8.08718 13.3399 8.17996 13.2616 8.27712 13.1789C9.00597 12.5585 9.97218 11.6972 10.9332 10.726C11.9005 9.74853 12.8282 8.69405 13.5043 7.68762C14.2122 6.63379 14.4994 5.84304 14.4994 5.3487C14.4994 3.62287 13.1525 2.2998 11.5807 2.2998C10.6339 2.2998 9.77296 2.77606 9.22081 3.5506L7.99263 5.27347ZM7.99939 15.3453C7.99939 15.3453 -0.000610352 9.17307 -0.000610352 5.3487C-0.000610352 2.8358 1.97712 0.799805 4.4181 0.799805C5.35409 0.799805 6.21871 1.09739 6.93064 1.6042C7.34354 1.89814 7.70508 2.26245 7.99939 2.67989C8.2962 2.26353 8.65869 1.90004 9.07111 1.60651C9.78517 1.09829 10.6489 0.799805 11.5807 0.799805C14.0217 0.799805 15.9994 2.8358 15.9994 5.3487C15.9994 9.17307 7.99939 15.3453 7.99939 15.3453Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "currentColor"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeartOutlinedWithoutFrame);
export default __webpack_public_path__ + "static/media/heartOutlinedWithoutFrame.a55e48d8.svg";
export { ForwardRef as ReactComponent };